import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ConfigService } from '$State/ConfigFreezerService';

const useVideoEventNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const onSelectVideoEvent = useCallback(
        (eventId: string, goBack: boolean = false, addHistoryState = true): void => {
            if (eventId) {
                const eventUrl = ConfigService.isRunningGeotabIntegrated() ? ',eventId:' : '?eventId=';
                let basePath = location.pathname + location.hash;

                // Remove any existing eventId segment so it is replaced, not appended.
                const tokenIndex = basePath.indexOf(eventUrl);
                if (tokenIndex !== -1) {
                    basePath = basePath.substring(0, tokenIndex);
                }

                const pathWithEvent = `${basePath}${eventUrl}'${eventId}'`;

                navigate(pathWithEvent, {
                    state: { eventId },
                    replace: !addHistoryState,
                });
            } else if (goBack) {
                navigate(-1);
            }
        },
        [ConfigService, location, navigate],
    );

    return { onSelectVideoEvent };
};

export { useVideoEventNavigation };
